import { combineReducers } from 'redux';
import commonReducer from './common/common.reducer';
import userStatsReducer from './common/userStats.reducer';

export const rootReducer = combineReducers({
  common: commonReducer,
  userStats: userStatsReducer,
});
